import { Inject, Injectable } from '@angular/core';
import { ProjectsService } from '../../services/projects.service';
import { BehaviorSubject, firstValueFrom, Observable } from 'rxjs';
import {
  BIMPointResponse,
  Floor,
  FloorDetailsResponse,
  Observation,
  PointImage,
  PointLog,
  ProjectDetails,
  ProjectFloorPoint,
  ProjectInfo,
  Report,
} from '../../models/project.model';
import { CurrentPImg } from '../project/classes/CurrentPImg';
import { ActiveControlsClass } from '../project/classes/active-controls-class';
import { GStatic } from '../../services/GStatic';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { ShareWithService } from '../../services/share-with.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ObservationsService } from '../../services/Observations/observations.service';
import { ProjectPlanningService } from './project-planning/project-planning.service';
import { FilesService } from './files-manager (deprecated)/files.service';
import { FilesService as FilesServiceOld } from '../../services/files.service';
import { RestfulEndpoint } from 'app/services/restful-endpoint.service';
import {
  BimDeleteFileResponse,
  BimFileStatusResponse,
  BimTokenResponse,
  Download,
  download,
} from '../../shared/classes/download';
import { SAVER, Saver } from 'app/shared/classes/saver.provider';
import _ from 'lodash';
import { AccessLevel } from '../../core/user/user.model';
import { ToastrService } from 'ngx-toastr';
import { BuildingObject, Project } from '../projects/projects-api-models';
import { TranslocoService } from '@ngneat/transloco';
import {
  ObservationCategory,
  ObservationDetails,
  ObservationDetailsResponse,
  ObservationRefactor,
  TopUserData,
} from '../../models/observations.model';
import { FileCategory, FileModel } from '../../models/files.model';
import { TeamMember } from '../../models/members.model';
import { ReportDetails } from '../../models/reports.model';
import { SafeUrl } from '@angular/platform-browser';
import { REPORT_TYPE } from '../project/const';
import { NavigationService } from '../project/components/navigation/navigation.service';
import { UserService } from 'app/core/user/user.service';
import { getProjectPlaceholderImage } from 'app/shared/utils/branded-placeholder.util';

export type State = 'loaded' | 'empty' | 'invalid' | 'noAccess' | 'error' | null;

@Injectable({
  providedIn: 'root',
})
export class Project360Service {
  public activeControls: ActiveControlsClass = new ActiveControlsClass({
    map: false,
    report: false,
    floor: false,
    points: false,
    observation: false,
    split: false,
    measure: false,
    splitBim: false,
    lockScreen: true,
    menu: true,
    autoTour: false,
    fullScreen: false,
    imageSettings: false,
  });

  // For Cashing
  defaultPoint: any = [];
  isInitializing: boolean = false;
  lastPdfReportImgs: string[] = null;
  lastPdfReportId: string = '';
  lastPdfSelectedFloor: string = '';
  lastPdfSelectedFloorPoint: string = '';
  lastCachedPdfFloorPointImages: string[] = null;
  lastCachedPdfPreviewFloorPointImages: SafeUrl[] = null;
  public filesCategoriesList: FileCategory[];
  selectedReport: any;
  selectedFloor: Floor;
  isFloorDetailsLoading: boolean = false;
  isImageOreintationUpdated: boolean;
  buildings: BuildingObject[];
  public allowedExtensions = [
    'pdf',
    'jpg',
    'jpeg',
    'png',
    'mp4',
    'pptx',
    'ppt',
    'xlsx',
    'xls',
    'csv',
    'dwg',
    'doc',
    'docx',
    'mov',
    'heic',
    'kmz',
  ];
  redirectedReportId: string;
  linkedReportId: string;
  measurementStatus: string = 'notReady';
  public lastFetched: string[] = []; //temp public for operation manager
  public pointsImages: PointImage[] = []; //temp public for operation manager
  public _fetches = new BehaviorSubject<string>(''); //temp public for operation manager
  //#endregion // isReady Subject & Observable
  readonly fetches$ = this._fetches.asObservable();
  public projectId: string = '';
  private state: State = null;
  public projectDetails: ProjectDetails = {};
  private pointsImagesById: PointImage[] = [];
  private pointsImagesBy: any = {};
  private observationsByPImgs: { [key: string]: ObservationRefactor[] } = {};
  private observationsByFloor: { [key: string]: ObservationRefactor[] } = {};
  private rolesGroup: string[] = null;
  private categories: ObservationCategory[] = null;
  private membersSubject = new BehaviorSubject<TeamMember[]>([]);
  private rolesSubject = new BehaviorSubject<string[]>([]);
  private catSubject = new BehaviorSubject<ObservationCategory[]>([]);
  readonly observationCategories = this.catSubject.asObservable();
  private floorDetails: any;
  private observationsSubject = new BehaviorSubject<Observation[]>([]);
  readonly observations$ = this.observationsSubject.asObservable();
  private pointLogSubject = new BehaviorSubject<PointLog[]>([]);
  private reportDetailsSubject = new BehaviorSubject<ReportDetails[]>([]);
  private observationDetails: { [key: string]: ObservationDetails } = {};
  private _isReadySubject = new BehaviorSubject<boolean>(false);
  // for caching
  private _isLoadingSubject = new BehaviorSubject<boolean>(false);
  private _currentPImgs: CurrentPImg[] = [];
  private _currentPImgsChanges = new BehaviorSubject<CurrentPImg>(null);
  public navigationHotspot = new BehaviorSubject<boolean>(false);
  protected readonly REPORT_TYPE = REPORT_TYPE;
  public selectedTempFloorId: string;
  public selectedTempImageId: string;

  public unifierPermission: boolean = false;

  public permissionsInitialized: boolean = false;

  // Observable properties for template binding
  private _startDate$ = new BehaviorSubject<string>(null);
  private _endDate$ = new BehaviorSubject<string>(null);
  private _totalCost$ = new BehaviorSubject<number>(null);
  private _projectDescription$ = new BehaviorSubject<string>(null);

  // Public observables
  public startDate$ = this._startDate$.asObservable();
  public endDate$ = this._endDate$.asObservable();
  public totalCost$ = this._totalCost$.asObservable();
  public projectDescription$ = this._projectDescription$.asObservable();

  constructor(
    private _projectsApi: ProjectsService,
    private shareWithService: ShareWithService,
    private filesService: FilesService,
    private filesServiceOld: FilesServiceOld,
    private shareService: ShareWithService,
    private observationsService: ObservationsService,
    private _router: Router,
    private _route: ActivatedRoute,
    private _translocoService: TranslocoService,
    private _projectPlanning: ProjectPlanningService,
    private endPoint: RestfulEndpoint,
    private _toaster: ToastrService,
    @Inject(SAVER) private save: Saver,
    private http: HttpClient,
    private _navigationService: NavigationService,
    private userService: UserService,
  ) {
    this.initPermissions();
  }

  private async initPermissions() {
    const user = await this.userService.getCurrentUser();

    this.unifierPermission =
      user.enable_project_unifier && this.userService.permissions.SYSTEM_UNIFIER_PROJECT_SYNC;

    this.permissionsInitialized = true;

    // Update observables when permissions are initialized
    this.updateProjectDataObservables();
  }

  private updateProjectDataObservables() {
    if (this.projectDetails) {
      this._startDate$.next(
        this.unifierPermission
          ? this.projectDetails?.unifier_start_date
          : this.projectDetails?.start_date,
      );

      this._endDate$.next(
        this.unifierPermission
          ? this.projectDetails?.unifier_end_date
          : this.projectDetails?.end_date,
      );

      this._totalCost$.next(
        this.unifierPermission
          ? this.projectDetails?.unifier_project_budget_sar
          : this.projectDetails?.total_cost,
      );

      this._projectDescription$.next(
        this.unifierPermission
          ? this.projectDetails?.unifier_project_scope
          : this.projectDetails?.project_description,
      );
    }
  }

  get _files(): FileModel[] {
    return this.filesService.files;
  }

  get files$(): Observable<FileModel[]> {
    return this.filesService.files$;
  }

  private _members: TeamMember[] = null;

  get members(): TeamMember[] {
    return this._members;
  }

  private _reportDetails: ReportDetails[] = [];

  get reportDetails(): ReportDetails[] {
    return this._reportDetails;
  }

  private _observations: Observation[] = null;

  get observations(): Observation[] {
    return this._observations;
  }

  private _pointLogs: PointLog[] = null;

  get pointLogs(): PointLog[] {
    return this._pointLogs;
  }

  get permissions(): string[] {
    return this.projectDetails.permissions;
  }

  //#region  --  Props

  private _observationTopUserData: TopUserData = null;

  get observationTopUserData(): TopUserData {
    return this._observationTopUserData;
  }

  //#endregion // End

  get isReady$(): Observable<boolean> {
    return this._isReadySubject.asObservable();
  }

  set setReady$(value: boolean) {
    this._isReadySubject.next(value);
  }

  //#region    isLoaded: boolean; --  isLoaded Subject & Observable
  private _isLoaded: boolean;

  get isLoaded(): boolean {
    return this._isLoaded;
  }

  set isLoaded(val: boolean) {
    this._isLoaded = val;
    this._isLoadingSubject.next(val);
  }

  setFloors(floors) {
    this.projectDetails.floors = floors;
  }

  setReports(reports) {
    this.projectDetails.reports = reports;
  }

  //#region  -- Getters Props

  get reports(): Report[] {
    return this.projectDetails?.reports;
  }

  get floors(): Floor[] | any[] {
    return this.projectDetails.floors;
  }

  get projectName(): string {
    return this.projectDetails?.project_name;
  }

  get id(): string {
    return this.projectDetails?.id;
  }

  /**
   * Whether this project is actually linked to Unifier, and so can take part in NWC sync.
   * Mirrors the backend's Projects::isUnifierLinked() (PC-2377) — read here rather than
   * re-derived, since the frontend has no project_number of its own to check against.
   */
  get unifierLinked(): boolean {
    return !!this.projectDetails?.unifier_is_linked;
  }

  /**
   * Whether this project is an NWC Cluster or Region — a container with sub-projects of its
   * own, rather than a real Unifier project (PC-2381). A container never carries a
   * project_number (Unifier has no concept of this hierarchy), so its missing link is expected,
   * not broken: syncing it means syncing the real projects underneath it, not itself.
   *
   * `children_projects_count` (not `level`) decides this: `level` alone is not a safe signal
   * here, since every root-level project on the platform defaults to level 1 regardless of
   * client or purpose.
   */
  get isUnifierHierarchyContainer(): boolean {
    return (this.projectDetails?.children_projects_count ?? 0) > 0;
  }

  get projectInfo(): ProjectInfo {
    return {
      isPointCloudEnabled: this.projectDetails.point_cloud_enabled,
      floorsCount: this.projectDetails.floors_count,
      lastReportId: this.projectDetails.Last_report_id,
      bim_files: this.projectDetails.bim_files,
      last_point_image: this.projectDetails.last_point_image,
      default_point: this.projectDetails.default_point_id,
      createdAt: this.projectDetails.created_at,
      createdBy: this.projectDetails.created_by,
      folderId: this.projectDetails.folder_id,
      id: this.projectDetails.id,
      isCreator: this.projectDetails.is_creator,
      asif_selected: this.projectDetails.asif_selected,
      asif_pipeline_status: this.projectDetails.asif_pipeline_status,
      locationAddress: this.projectDetails.location_address,
      locationLat: this.projectDetails.location_lat,
      locationLng: this.projectDetails.location_lng,
      projectLogo: getProjectPlaceholderImage(
        this.projectDetails.project_logo,
        this.isNwcClientSync(),
      ),
      projectName: this.projectDetails.project_name,
      projectNameEn: this.projectDetails.project_name_en,
      organizationSettings: this.projectDetails.organization_settings,
      organization_features: this.projectDetails.organization_features,
      totalAreaSpace: this.projectDetails.total_area_space,
      totalAreaUnit: this.projectDetails.total_area_unit,
      reportsCount: this.projectDetails.reports_count,
      floorCount: this.projectDetails.floor_count,
      projectManagerEmail: this.projectDetails.project_manager_email,
      projectManager: this.projectDetails.project_manager,
      projectDescription: this.projectDetails.project_description,
      projectManagerId: this.projectDetails.project_manager_id,
      projectManagerAssignedAt: this.projectDetails.pm_assign_at,
      isProjectManager: this.projectDetails.is_project_manager,
      is_cloned: this.projectDetails.is_cloned,
      is_clone_source: this.projectDetails.is_clone_source,
      sync_status: this.projectDetails.sync_status,
      projectManagerStatus: this.projectDetails.project_manager_status,
      tags: this.projectDetails.tags,
      is_archived: this.projectDetails.is_archived,
      permissions: this.projectDetails.permissions,
      user_project_role: this.projectDetails.user_project_role,
      totalCost: this.projectDetails.total_cost,
      childrenProjectsCount: this.projectDetails.children_projects_count,
      level: this.projectDetails.level,
      parent: this.projectDetails.parent,
      blurFacePL: this.projectDetails.blur_human_faces_enabled,
      ppeAIDetectionPL: this.projectDetails.ppe_detection_enabled,
      observations_count: this.projectDetails.observations_count,
      start_date: this.projectDetails.start_date,
      end_date: this.projectDetails.end_date,
      unifier_start_date: this.projectDetails.unifier_start_date,
      unifier_end_date: this.projectDetails.unifier_end_date,
      unifier_is_synced: this.projectDetails.unifier_is_synced,
      unifier_ref_number: this.projectDetails.unifier_ref_number,
      unifier_project_admin: this.projectDetails.unifier_project_admin,
      unifier_updated_at: this.projectDetails.unifier_updated_at,
      unifier_created_at: this.projectDetails.unifier_created_at,
      unifier_data: this.projectDetails.unifier_data,
      consultant_image: this.projectDetails.consultant_image,
      contractor_image: this.projectDetails.contractor_image,
      supervision_image: this.projectDetails.supervision_image,
      capacity: this.projectDetails.capacity,
      pmc: this.projectDetails.pmc,
      contractor: this.projectDetails.contractor,
      sub_contractor: this.projectDetails.sub_contractor,
      contract_number: this.projectDetails.contract_number,
      engineer: this.projectDetails.engineer,
      autodesk_account: this.projectDetails.autodesk_account,
      // Unifier Integration Fields - Map from API response with unifier_ prefix
      project_scope: this.projectDetails.unifier_project_scope,
      project_number: this.projectDetails.unifier_project_id,
      cluster: this.projectDetails.unifier_cluster,
      region: this.projectDetails.unifier_region,
      latitude: this.projectDetails.unifier_latitude,
      longitude: this.projectDetails.unifier_longitude,
      project_budget_sar: this.projectDetails.unifier_project_budget_sar,
      p6_project_id: this.projectDetails.unifier_p6_project_id,
      project_status: this.projectDetails.unifier_project_status,
      // NWC Integration
      shared_by: this.projectDetails.shared_by,
      v2_project_id: this.projectDetails.v2_project_id,
      key: this.projectDetails.key,
    };
  }

  get currentPImg(): CurrentPImg {
    return this._currentPImgs[0];
  }

  get secondPImg(): CurrentPImg {
    return this._currentPImgs[1];
  }

  //#endregion // Props
  reset(): void {
    this.projectId = '';
    this._members = [];
    this.projectDetails = {};
    sessionStorage.removeItem('v2_project_id');
    this.pointsImages = [];
    this.pointsImagesBy = {};
    this.activeControls.set({
      map: false,
      report: false,
      floor: false,
      points: false,
      observation: false,
      split: false,
      lockScreen: true,
      menu: true,
      autoTour: false,
      fullScreen: false,
    });
    this.state = 'empty';
    this._observations = [];

    this._isReadySubject = new BehaviorSubject<boolean>(false);
    this.defaultPoint = [];
    this.lastPdfReportImgs = null;
    this.lastPdfReportId = null;
    this.lastCachedPdfFloorPointImages = null;
    this.lastCachedPdfPreviewFloorPointImages = null;
    this._reportDetails = [];
    this.filesCategoriesList = undefined;
    this.filesService.reset();
    this._projectPlanning.reset();
  }

  public reloadCurrentRoute(): void {
    const currentUrl = this._router.url;
    const urlWithoutParams = currentUrl.split('?')[0]; // Get the URL without query parameters
    this._router.navigateByUrl('/', { skipLocationChange: true }).then(async () => {
      await this._router.navigate([urlWithoutParams]);
    });
  }

  //#endregion // Getters Props

  //#region  -- Fetches
  async fetchProjectDetails(): Promise<void> {
    if (this.projectId) {
      const res = await this._projectsApi
        .getProjectDetails(this.projectId)
        .toPromise()
        .catch((e: HttpErrorResponse) => {
          if (e.status === 400) {
            this._toaster.warning('Error ' + e.message);
            this.state = 'invalid';
          } else if (e.status === 403) {
            this._toaster.warning('Error ' + e.message);
            this.state = 'noAccess';
          } else {
            this.state = 'error';
            this._toaster.warning('Error ' + e.message);
          }
          this._router.navigate(['/403'], { queryParams: { prev: window.location.pathname } });
        });
      if (res) {
        this.state = 'loaded';

        this.projectDetails = res.project_details;

        // Bridged via sessionStorage so the static GIS nav handler (nav-data.ts) can read it without Angular DI
        if (this.projectDetails.v2_project_id) {
          sessionStorage.setItem('v2_project_id', this.projectDetails.v2_project_id);
        }

        this.lastFetched.push('ProjectDetails');
        this._fetches.next('ProjectDetails');

        // Update observables when project details are fetched
        this.updateProjectDataObservables();
      }
    }
  }

  async fetchBuildings(project_id?: string) {
    if (!this.projectDetails.id) {
      return;
    }
    const buildingResponse = await firstValueFrom(
      this._projectsApi.getBuildings(project_id ?? null),
    );

    this.buildings = buildingResponse.data;
    this.lastFetched.push('Buildings');
    this._fetches.next('Buildings');
  }

  async fetchPointImages(
    reportId?: string,
    force?: boolean,
    replace?: boolean,
    floorID?: string,
  ): Promise<void> {
    let user = JSON.parse(localStorage.getItem('user-data')) || '';

    if (!this.projectDetails.id || user.role_name == 'ORG_OPERATION_ENGINEER') {
      return;
    }

    if (force) {
      this.pointsImages = []; // Clear the existing images if force fetch is true
    }

    const pointResponse = await firstValueFrom(
      this._projectsApi.getPointImages(this.projectId, reportId ?? this.reports[0].id),
    );

    const newImages = pointResponse.point_images;

    if (replace) {
      // If replace is true, replace existing images with new ones
      newImages.forEach((newImage) => {
        const existingIndex = this.pointsImages.findIndex(
          (existingImage) => existingImage.id === newImage.id,
        );
        if (existingIndex !== -1) {
          this.pointsImages[existingIndex] = newImage;
        } else {
          this.pointsImages.push(newImage);
        }
      });
    } else {
      // If replace is false, skip existing images and only add new ones
      this.pointsImages = this.pointsImages.concat(
        newImages.filter((newImage) => {
          return !this.pointsImages.some((existingImage) => existingImage.id === newImage.id);
        }),
      );
    }

    this.lastFetched.push('PointImages');
    this._fetches.next('PointImages');
    setTimeout(() => {
      this.isInitializing = false;
    }, 5000);
  }

  async fetchObservations(pImgId) {
    if (!this.projectDetails.id || this.pointsImages.length == 0) {
      return;
    }

    const thisPImg = this.getPImg(pImgId);
    return new Promise((resolve, reject) => {
      this.observationsService.resetObservationFilter();
      this.observationsService._observationFilter.floor_id = thisPImg.floor_id;
      this.observationsService._observationFilter.point_id = thisPImg.point_id;

      // Use the report_id from the URL parameters
      this.observationsService._observationFilter.report_id =
        this._route.snapshot.queryParams['report_id'] || thisPImg.report_id;

      if (
        this._route.snapshot.queryParams['report_id'] &&
        this.selectedReport &&
        this._route.snapshot.queryParams['report_id'] != this.selectedReport.id
      ) {
        this.observationsService._observationFilter.report_id = this.selectedReport.id;
      }

      this.observationsService.per_page = 300;
      this.observationsService._observationFilter.observation_flag = 'observation_on_360';
      this.observationsService.getObservationsRefactored(this.projectId).subscribe(
        (response) => {
          this.observationsByPImgs[pImgId] = response.data;
          resolve(response.data);
          this.lastFetched.push('Observations');
          this._fetches.next('Observations');
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  async fetchObservationDetails(observationId: string): Promise<ObservationDetails> {
    // if (!this.projectDetails.id) {
    //   return;
    // }
    const observationDetailsResponse = await this.observationsService
      .getObservationDetails(observationId)
      .toPromise();
    this.observationDetails[observationId] = observationDetailsResponse.observation_details;

    this.lastFetched.push('observationDetailsResponse');
    this._fetches.next('observationDetailsResponse');
    return observationDetailsResponse.observation_details;
  }

  async fetchFloorObservations(floor_id, project_id): Promise<ObservationRefactor[]> {
    return new Promise((resolve, reject) => {
      this.observationsService.resetObservationFilter();
      this.observationsService._observationFilter.floor_id = floor_id;
      this.observationsService._observationFilter.observation_flag = 'observation_on_floor_plan';
      this.observationsService.per_page = 300;
      this.observationsService.getObservationsRefactored(project_id).subscribe(
        (response) => {
          this.observationsByFloor[floor_id] = response.data;
          this.lastFetched.push('FloorObservations');
          this._fetches.next('FloorObservations');
          resolve(response.data);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  async fetchFloorDetails(floorId): Promise<FloorDetailsResponse> {
    if (!this.projectDetails.id) {
      return;
    }
    const body = {
      id: floorId,
    };
    const floorDetailsResponse = await this._projectsApi.getFloorDetails(body).toPromise();
    this.floorDetails = floorDetailsResponse;
    this._pointLogs = this.floorDetails.floor_details.logs;
    this.lastFetched.push('FloorDetails');
    this._fetches.next('FloorDeails');
    return floorDetailsResponse;
  }

  async fetchFloorObservationsByFloorId(
    floor_id: string,
    isAll: boolean = false,
    reportId?: string,
  ): Promise<ObservationRefactor[]> {
    if (!this.projectDetails.id) {
      return;
    }
    return new Promise((resolve, reject) => {
      this.observationsService.resetObservationFilter();
      this.observationsService.per_page = 300;
      this.observationsService._observationFilter.floor_id = floor_id;
      if (!isAll) {
        this.observationsService._observationFilter.observation_flag = 'observation_on_floor_plan';
      } else {
        delete this.observationsService._observationFilter.observation_flag;
      }
      if (reportId) {
        this.observationsService._observationFilter.report_id = reportId;
      }
      this.observationsService.getObservationsRefactored(this.projectId).subscribe(
        (response) => {
          this.lastFetched.push('FloorObservations');
          this._fetches.next('FloorObservations');
          this.observationsByPImgs[floor_id] = response.data;
          resolve(response.data);
        },
        (error) => {
          reject(error);
        },
      );
    });
  }

  async fetchFloorObservationsByFloorIdSubscriber(floor_id: string) {
    if (!this.projectDetails.id) {
      return;
    }
    this.observationsService.resetObservationFilter();
    this.observationsService.per_page = 300;
    this.observationsService._observationFilter.floor_id = floor_id;
    this.observationsService._observationFilter.observation_flag = 'observation_on_floor_plan';
    this.observationsService.getObservationsRefactored(this.projectId).subscribe((response) => {
      this.lastFetched.push('FloorObservations');
      this.observationsByPImgs[floor_id] = response.data;
      this._fetches.next('FloorObservations');
    });
  }

  async fetchMembers(): Promise<Observation[]> {
    GStatic.log('called fetch');
    if (!this.projectDetails.id) {
      return;
    }

    this._isLoadingSubject.next(true);
    const membersResponse = await this.shareWithService
      .getProjectMembers(this.projectDetails.id)
      .toPromise();
    this._members = membersResponse.team_members;
    this.membersSubject.next(this._members);
    this.lastFetched.push('TeamMembers');
    this._fetches.next('TeamMembers');
    this._isLoadingSubject.next(false);
    return this._members;
  }

  /**
   * Append newly shared members to the in-memory list without refetching.
   */
  addMembersLocally(newMembers: TeamMember[]): void {
    if (!newMembers?.length) {
      return;
    }
    if (!this._members) {
      this._members = [];
    }
    const existingIds = new Set(this._members.map((m) => m.user_id));
    const toAdd = newMembers.filter((m) => m?.user_id && !existingIds.has(m.user_id));
    if (!toAdd.length) {
      return;
    }
    this._members = [...this._members, ...toAdd];
    this.membersSubject.next(this._members);
  }

  /* async fetchAllObservations(): Promise<Observation[]> {
     if (!this.projectDetails.id) {
       return;
     }
     this._isLoadingSubject.next(true);

     const observationsResponse = await this.observationsService
       .getObservations({ project_id: this.id })
       .toPromise();
     this._observations = observationsResponse.observation_list;
     this.observationsSubject.next(this._observations);
     this.lastFetched.push('AllObservations');
     this._fetches.next('AllObservations');
     this._isLoadingSubject.next(false);
     return observationsResponse.observation_list;
   }*/

  async fetchReportsDetails(): Promise<ReportDetails[]> {
    if (!this.projectDetails.id) {
      return;
    }
    this._isLoadingSubject.next(true);
    for (const report of this.reports) {
      const res = await this.getReportDetailsById(report.id);
      this._reportDetails.push(res);
    }
    this.reportDetailsSubject.next(this._reportDetails);
    this.lastFetched.push('ReportDetails');
    this._fetches.next('ReportDetails');
    this._isLoadingSubject.next(false);
    return this._reportDetails;
  }

  /* Files Fetches */
  async fetchFiles(force: boolean = false): Promise<FileModel[]> {
    if (!this.projectDetails.id) {
      return;
    }
    if (force) {
      await this.filesService.fetch(this.id, true);
      this._isLoadingSubject.next(true);

      this.lastFetched.push('Files');
      this._fetches.next('Files');
      this._isLoadingSubject.next(false);
      return this._files;
    }
  }

  async fetchFilesCategoriesList(): Promise<FileCategory[]> {
    // TODO
    const fileCategoryResponse = await this.filesServiceOld
      .getCategories(this.projectId)
      .toPromise();
    this.filesCategoriesList = fileCategoryResponse.categories;
    return this.filesCategoriesList;
  }

  async fetchSubFolders(parent_id?: string): Promise<FileCategory[]> {
    // TODO
    const fileCategoryResponse = await this.filesServiceOld
      .getCategories(this.projectId, parent_id)
      .toPromise();
    return fileCategoryResponse.categories;
  }

  async fetchRoleGroups(): Promise<any> {
    if (!this.projectDetails.id) {
      return;
    }
    this._isLoadingSubject.next(true);
    const roleResponse = await this.shareWithService.getRolesGroups().toPromise();
    this.rolesGroup = roleResponse.roles;
    this.rolesSubject.next(this.rolesGroup);
    this.lastFetched.push('RoleGroup');
    this._fetches.next('RoleGroup');
    this._isLoadingSubject.next(false);
    return this.rolesGroup;
  }

  async fetchObservationCategories(): Promise<any> {
    if (!this.projectDetails.id) {
      return;
    }
    this._isLoadingSubject.next(true);
    const catResponse = await this.observationsService.observationCategories().toPromise();
    this.categories = catResponse.observation_categories;
    this.catSubject.next(this.categories);
    this.lastFetched.push('observationCat');
    this._fetches.next('observationCat');
    this._isLoadingSubject.next(false);
    return this.categories;
  }

  async fetchTopUserChartData(dateParams?: any): Promise<any> {
    if (!this.projectDetails.id) {
      return;
    }
    this._isLoadingSubject.next(true);
    await this.observationsService
      .topUserData(this.id, dateParams)
      .toPromise()
      .then(
        (res) => {
          this._observationTopUserData = res;
          this.lastFetched.push('topUserData');
          this._fetches.next('topUserData');
        },
        (err) => {
          this._isLoadingSubject.next(false);
          return this._observationTopUserData;
        },
      );
    // this.catSubject.next(this.categories);
  }

  //#endregion

  async init(projectId: string, lazy = false): Promise<State> {
    this.linkedReportId = this._route.snapshot.queryParams['report_id'];
    this.isInitializing = true;
    if (this.projectId !== projectId) {
      this._isLoadingSubject.next(true);
      this.reset();

      this.projectId = projectId;
      // get Project Details;
      await this.fetchProjectDetails();

      if (!lazy) {
        let targetReportId =
          this.linkedReportId ??
          this.projectInfo.lastReportId ??
          this.projectDetails?.reports?.[0]?.id;

        if (!targetReportId) {
          this.isInitializing = false;
          this._isLoadingSubject.next(false);
          this._isReadySubject.next(true);
          return this.state;
        }

        let report;
        try {
          report = await this._projectsApi.getReportDefaultFloor(targetReportId).toPromise();
        } catch (error) {
          const httpError = error as HttpErrorResponse;
          const isReportNotFound = httpError?.status === 404;

          if (isReportNotFound && this.linkedReportId) {
            this._toaster.warning(
              this._translocoService.translate('Report is no longer available.'),
            );
            this.isInitializing = false;
            this._isLoadingSubject.next(false);
            this._isReadySubject.next(true);
            await this._router.navigate(['/project-d', this.projectId, 'report-management'], {
              replaceUrl: true,
            });
            return this.state;
          }

          if (isReportNotFound) {
            targetReportId = this.projectDetails?.reports?.[0]?.id;
          } else {
            this.isInitializing = false;
            this._isLoadingSubject.next(false);
            this.state = 'error';
            this._isReadySubject.next(true);
            this._toaster.error(
              this._translocoService.translate('An unexpected error occurred. Please try again.'),
            );
            return this.state;
          }
        }
        let user: { role_name?: string } = {};
        try {
          user = JSON.parse(localStorage.getItem('user-data') || '{}') || {};
        } catch {
          user = {};
        }

        if (!report?.data && user.role_name !== 'ORG_OPERATION_ENGINEER') {
          // revert back to old ways if we don't get report
          const newReports = await this._navigationService.fetchReports(
            this.projectDetails.id,
            this.reports.length,
            1,
          );
          this.setReports(newReports);
          const fallbackReportId = targetReportId ?? this.projectDetails?.reports?.[0]?.id;
          if (fallbackReportId) {
            await this.getPointImagesByFloor(fallbackReportId, null);
          }
        } else if (this.projectDetails.id && user.role_name !== 'ORG_OPERATION_ENGINEER') {
          this.selectedTempFloorId = report.data.floor_id;
          this.selectedTempImageId = report.data.image_id;
          await this.getPointImagesByFloor(targetReportId, this.selectedTempFloorId);
        }
      }
      this._isLoadingSubject.next(false);
      this._isReadySubject.next(true);

      //  this._isReadySubject.complete();
    }

    return this.state;
  }

  async getPointImagesByFloor(
    reportID: any,
    floorID: any,
    force: boolean = false,
    replace: boolean = false,
  ) {
    // for fallback in case we dont get report id or floor id 360 viewer should not stop.
    if (!reportID) {
      reportID = this.projectDetails.reports[0].id;
    }

    let reportFinal = this.projectDetails.reports.find((rep) => rep.id === reportID);
    if (!reportFinal) {
      this.isInitializing = false;
      return;
    }

    if (!floorID) {
      const floor =
        reportFinal?.report_floors?.find((fl) => fl.status === 'PUBLISHED_BY_OPERATION_ENG') ??
        reportFinal?.report_floors?.[0];
      if (!floor?.floor_id) {
        this.isInitializing = false;
        this._toaster.warning(this._translocoService.translate('No Floors'));
        return;
      }
      floorID = floor.floor_id;
    }

    if (force) this.pointsImages = [];

    if (
      this.pointsImages.find((p) => p.report_id === reportID && p.floor_id === floorID) &&
      !replace
    ) {
      return;
    }

    let points: any;

    if (reportFinal.report_type == REPORT_TYPE.VIDEOS) {
      points = await this._projectsApi.getFullPath(reportFinal.id, false, floorID).toPromise();
    } else {
      points = await this._projectsApi.getPointImagesByFloorId(reportFinal.id, floorID).toPromise();
    }

    const newImages = points.data;

    if (replace) {
      // If replace is true, replace existing images with new ones
      newImages.forEach((newImage) => {
        const existingIndex = this.pointsImages.findIndex(
          (existingImage) => existingImage.id === newImage.id,
        );
        if (existingIndex !== -1) {
          this.pointsImages[existingIndex] = newImage;
        } else {
          this.pointsImages.push(newImage);
        }
      });
    } else {
      // If replace is false, skip existing images and only add new ones
      this.pointsImages = this.pointsImages.concat(
        newImages.filter((newImage) => {
          return !this.pointsImages.some((existingImage) => existingImage.id === newImage.id);
        }),
      );
    }

    if (reportFinal.report_type == REPORT_TYPE.VIDEOS) {
      await this.getMatchingPoints(reportFinal.id, floorID);
      this.getNavigationHotspots(reportFinal.id, floorID);
    }

    this.lastFetched.push('PointImages');
    this._fetches.next('PointImages');
    setTimeout(() => {
      this.isInitializing = false;
    }, 5000);
  }

  async getNavigationHotspots(reportId: string, floorId: string) {
    try {
      this.navigationHotspot.next(true);
      const navigationResponse = await this._projectsApi
        .getNavigationHotspots(reportId, floorId)
        .toPromise();
      if (navigationResponse.data) {
        let hotspotPoints = navigationResponse.data;
        this.pointsImages.forEach((point) => {
          !point.navigation_hotspots ? (point.navigation_hotspots = []) : null;
          hotspotPoints.forEach((hPoint) => {
            if (hPoint.current_point_uuid === point.id) {
              point.navigation_hotspots.push(hPoint);
            }
          });
        });
        this.navigationHotspot.next(false);
      }
    } catch (e) {
      this.navigationHotspot.next(false);
      e?.error?.errors?.forEach((errorMessage: string) => {
        this._toaster.error(errorMessage); // Show error messages
      });
    }
  }

  async getMatchingPoints(reportId: string, floorId: string) {
    try {
      const matchingResponse = await this._projectsApi
        .getMatchingPoints(reportId, floorId)
        .toPromise();
      if (matchingResponse.data) {
        let matchingPoints = matchingResponse.data;
        this.pointsImages.forEach((point) => {
          !point.matching_points ? (point.matching_points = []) : null;
          matchingPoints.forEach((mPoint) => {
            if (mPoint.current_point_uuid === point.id) {
              point.matching_points.push(mPoint);
            }
          });
        });
      }
    } catch (e) {
      e?.error?.errors?.forEach((errorMessage: string) => {
        this._toaster.error(errorMessage); // Show error messages
      });
    }
  }

  async initCurrentPImg(
    pImgId: 'auto' | string = 'auto',
    priority: number = 0,
    fetchObservations = true,
  ): Promise<CurrentPImg> {
    // priority:0 is the current main Pano
    // priority:1 is the current second Pano (for Split)
    this._currentPImgs[priority] = new CurrentPImg(this, pImgId);
    this._currentPImgsChanges.next(this._currentPImgs[priority]);
    if (pImgId === 'auto') {
      pImgId = this._currentPImgs[priority].id;
    }
    if (
      pImgId &&
      !this.observationsByPImgs[pImgId] &&
      fetchObservations &&
      !this.isOperationEngineer()
    ) {
      await this.fetchObservations(pImgId).catch((error) => {
        this._toaster.error(error?.error?.message);
      });
    }

    return this._currentPImgs[priority];
  }

  assignProjectManager(uuid: string): any {
    return this._projectsApi.assignProjectManager(this.projectId, uuid);
  }

  async initEmptyCurrentPImg(
    point: ProjectFloorPoint | null | undefined,
    floorId: string,
    reportId: string,
    priority: number = 0,
  ): Promise<CurrentPImg> {
    this._currentPImgs[priority] = new CurrentPImg(this);
    this._currentPImgs[priority].initEmptyPoint(point, floorId, reportId);
    this._currentPImgsChanges.next(this._currentPImgs[priority]);
    return this._currentPImgs[priority];
  }

  //#region  -- Getters Functions

  async getPointImagesByPointId(point_id: string): Promise<{ [key: string]: PointImage[] }> {
    const pointResponse = await this._projectsApi.getPointImagesByPointId(point_id).toPromise();
    this.pointsImagesById = pointResponse.point_images;
    this.lastFetched.push('PointImagesById');
    this._fetches.next('PointImagesById');

    const groupedPointImages: { [key: string]: PointImage[] } = {};
    pointResponse.point_images.forEach((pointImage) => {
      if (!groupedPointImages[pointImage.point_id]) {
        groupedPointImages[pointImage.point_id] = [];
      }
      groupedPointImages[pointImage.point_id].push(pointImage);
    });

    return groupedPointImages;
  }

  async getPImgsGroupedBy(
    key: 'point' | 'floor' | 'report' | 'project',
  ): Promise<{ [key: string]: PointImage[] }> {
    const keyMap = {
      point: 'point_id',
      floor: 'floor_id',
      report: 'report_id',
    };
    if (this.pointsImages.length === 0) {
      await this.getPointsImages();
    }
    if (!this.pointsImagesBy[key]) {
      const groupedPoints = {};
      this.pointsImages.forEach((img) => {
        if (!groupedPoints[img[keyMap[key]]]) {
          groupedPoints[img[keyMap[key]]] = [];
        }
        groupedPoints[img[keyMap[key]]] = [...groupedPoints[img[keyMap[key]]], img];
      });
      this.pointsImagesBy[key] = groupedPoints;
    }
    return this.pointsImagesBy[key];
  }

  filterPImgsBy(
    key: 'point' | 'floor' | 'report' | 'project' | 'matchingPoint',
    id: string,
  ): PointImage[] {
    const keyMap = {
      point: 'point_id',
      floor: 'floor_id',
      report: 'report_id',
    };
    if (key === 'matchingPoint') {
      return this.pointsImages.filter((img) => {
        if (img.matching_points) img.matching_points[0]?.match_point_uuid === id;
      });
    } else {
      return this.pointsImages.filter((img) => img[keyMap[key]] === id);
    }
  }

  filterPointsByReportAndFloor(reportId, floorId): PointImage[] {
    return _.filter(this.pointsImages, {
      floor_id: floorId,
      report_id: reportId,
    });
  }

  mappedVideoPointFromPointImage(reportId, floorId) {
    return this.filterPointsByReportAndFloor(reportId, floorId).map((res, index) => {
      return {
        is_default: index === 0 ? true : false,
        id: res.id,
        lat: res.lat,
        lng: res.lng,
        point_name: res.point_name,
        point_x: res.point_x,
        point_y: res.point_y,
        is_selected_point: res.is_selected_point,
        map_point_radius: res.map_point_radius,
      };
    });
  }

  getDefaultPoint(): any {
    this.defaultPoint = [];
    this.projectDetails.floors.forEach((floor) => {
      floor.floor_points.forEach((point) => {
        if (point.is_default === true) {
          this.defaultPoint = { ...point, ...floor };
        } else {
          return null;
        }
      });
    });
    return this.defaultPoint;
  }

  removeMember(id: string): any {
    return this.shareService.removeMember(id, this.id);
  }

  updateMemberResponsibilities(body: any): any {
    return this.shareService.update_member_responsibilities(body);
  }

  updateMemberRole(body: any): any {
    return this.shareService.updateMemberRole(body);
  }

  searchUsers(value: any): any {
    return this.shareService.searchUsers(value);
  }

  deleteProject(id: any): any {
    return this._projectsApi.deleteProject(id);
  }

  deleteFloor(id: string, project_id: string): any {
    return this._projectsApi.deleteFloor(id, project_id);
  }

  editFloor(body: { floor_name: string; floor_id: string; project_id: string }): any {
    return this._projectsApi.editFloor(body);
  }

  cloneFloor(body: { floor_name: string; floor_id: string }): any {
    return this._projectsApi.cloneFloor(body);
  }

  reOrderFloors(body: any): any {
    return this._projectsApi.reOrderFloorsList(body);
  }

  toggleFloorObservationCreation(floorId: string, isEnabled: boolean): Observable<any> {
    return this._projectsApi.toggleFloorObservationCreation(floorId, isEnabled);
  }

  reOrderPoints(body: any): any {
    return this._projectsApi.reOrderFloorPointsList(body);
  }

  deletePoint(body: any): any {
    return this._projectsApi.deletePoint(body);
  }

  // action
  async setDefaultPoint(pointId: string, project_id: string): Promise<any> {
    const result = await this._projectsApi.setDefaultPoint(pointId, project_id).toPromise();
    await this.fetchProjectDetails();
    this.getDefaultPoint();
    return result;
  }

  async getRolesGroups(): Promise<string[]> {
    this._isLoadingSubject.next(true);
    this.rolesGroup = await this.fetchRoleGroups();
    this._isLoadingSubject.next(false);
    return this.rolesGroup;
  }

  getReportById(id: string): Report {
    const baseReport = this.reports?.find((e) => e?.id === id);
    const reportList = this._navigationService?.reportList?.data || [];
    let refactoredReport: Report | undefined;

    for (let index = reportList.length - 1; index >= 0; index--) {
      if (reportList[index]?.id === id) {
        refactoredReport = reportList[index];
        break;
      }
    }

    if (baseReport && refactoredReport) {
      return { ...baseReport, ...refactoredReport };
    }

    return (refactoredReport || baseReport) as Report;
  }

  async getReportDetailsById(id: string): Promise<ReportDetails> {
    const response = await this._projectsApi.getReportDetails(id).toPromise();
    return response.reports;
  }

  async getPointsImages(force?: boolean): Promise<PointImage[]> {
    if (!this.pointsImages.length || force) {
      this._isLoadingSubject.next(true);
      await this.getPointImagesByFloor(this.selectedReport.id, this.selectedFloor.id);
      this._isLoadingSubject.next(false);
    }
    return structuredClone(this.pointsImages);
  }

  getObservationsByPImgs(PImgId: string): ObservationRefactor[] {
    return this.observationsByPImgs[PImgId];
  }

  getObservationsByFloor(floorId: string): ObservationRefactor[] {
    return this.observationsByFloor[floorId];
  }

  /**
   * V2CORE-2901: drop the cached observations per point image and per floor, so the 360 viewer
   * fetches them again on the next view (for example after the AI observations were removed).
   * A point or floor is re-fetched only when its entry is missing, so emptying the maps is enough.
   */
  clearObservationCaches(): void {
    this.observationsByPImgs = {};
    this.observationsByFloor = {};
  }

  getPImg(PImgId: string): PointImage {
    const pointImageCheck = this.pointsImages.find((pImg) => pImg.id === PImgId);
    if (pointImageCheck) {
      return pointImageCheck;
    } else {
      return this.pointsImages[0];
    }
  }

  async getPImgFrom(
    reportId: string,
    floorId: string | null,
    pointId: string,
  ): Promise<PointImage> {
    await this.getPointImagesByFloor(reportId, floorId);
    if (pointId) {
      return this.pointsImages.find(
        (pImg) => pImg.report_id === reportId && pImg.point_id === pointId,
      );
    } else {
      return this.pointsImages.find((pImg) => pImg.report_id === reportId);
    }
  }

  getFloor(floorId: string): Floor {
    return this.floors.find((floor) => floor.id === floorId);
  }

  deleteReport(reportId: string): any {
    return this._projectsApi.deleteReport(reportId, this.projectId);
  }

  unmergeReport(reportId: string): any {
    return this._projectsApi.unmergeReport(reportId, this.projectId);
  }

  renameReport(body: any): any {
    return this._projectsApi.renameReport(body);
  }

  mergeReports(body: any): any {
    return this._projectsApi.mergeReports(body);
  }

  showHidePoint(body: any): any {
    return this._projectsApi.showHidePoint(body);
  }

  async getMembers(force?: boolean): Promise<TeamMember[]> {
    GStatic.log('force', force);
    if (!this._members || this._members.length === 0 || force) {
      this._isLoadingSubject.next(true);
      await this.fetchMembers();
      this._isLoadingSubject.next(false);
    }
    return this._members;
  }

  async getObservationCategories(): Promise<ObservationCategory[]> {
    if (!this.categories) {
      this._isLoadingSubject.next(true);
      await this.fetchObservationCategories();
      this._isLoadingSubject.next(false);
    }
    return this.categories;
  }

  getObservationDetailsAPI(observation_id: string): Observable<ObservationDetailsResponse> {
    return this.endPoint.post('get_observation_details', { observation_id });
  }

  getTimeLapseVideo({
    project_id,
    point_id,
    requested,
  }: {
    project_id: string;
    point_id: string;
    requested: boolean;
  }): Observable<{ timelapse_zip_file: string; waiting: boolean }> {
    return this.endPoint.post('get_timelapse_zip_file', {
      project_id,
      point_id,
    });
  }

  /**
   * Check the permission
   */

  getPermission(access: AccessLevel): boolean {
    if (this.projectDetails?.permissions?.includes(access)) {
      return true;
    } else {
      return false;
    }
  }

  getProjectPermission(access: AccessLevel, project: Project): boolean {
    return !!project.permissions?.includes(access);
  }

  getUserRole(): string {
    return this.projectDetails?.user_project_role;
  }

  download(url: string, filename?: string): Observable<Download> {
    return this.http
      .get(url, {
        reportProgress: true,
        observe: 'events',
        responseType: 'blob',
      })
      .pipe(download((blob) => this.save(blob, filename)));
  }

  async deleteAttached(attachedId: string, projectId: string): Promise<boolean> {
    const res: { success: boolean } = await this.endPoint
      .post('delete_attached', {
        id: attachedId,
        project_id: projectId,
      })
      .toPromise();
    if (res?.success) {
      return true;
    }
  }

  async deleteEvidence(observationId: string): Promise<any> {
    const res = await firstValueFrom(
      this.endPoint.delete(`v2/observations/${observationId}/delete-evidence-file`),
    );

    if (res) {
      return true;
    }
  }

  //#endregion // Getters Functions
  getBimToken(project_id: string): Observable<BimTokenResponse> {
    return this.endPoint.post('get_autodesk_access_token', { project_id });
  }

  getBimFileStatus(project_id: string, urn: string): Observable<BimFileStatusResponse> {
    return this.endPoint.post('bim_file_status', { project_id, urn });
  }

  sendBimPoint(data: BIMPointResponse): Observable<any> {
    return this.endPoint.post('save_bim_floor_points', data);
  }

  deleteBIMFile(project_id: string, file_id: string): Observable<BimDeleteFileResponse> {
    return this.endPoint.post('delete_bim_file', { project_id, file_id });
  }

  setImageOreintation(
    reportId: string,
    pImageId: string,
    verticalAngle: number,
    horizontalAngle: number,
  ) {
    let body = {
      report_id: reportId,
      point_image_id: pImageId,
      vertical_angle: verticalAngle,
      horizontal_angle: horizontalAngle,
    };

    this.endPoint.post('set_default_point_image_direction', body).subscribe(
      async (response) => {
        await this.getPointImagesByFloor(reportId, this.currentPImg.floor_id, false, true);
        this.isImageOreintationUpdated = true;
        this.currentPImg.horizontal_angle = horizontalAngle;
        this.currentPImg.vertical_angle = verticalAngle;

        this._toaster.success(
          this._translocoService.translate('Image direction updated successfully'),
        );
      },
      (error) => {
        console.error('An error occurred:', error);
        this._toaster.error(error.message);
      },
    );
  }

  async setBimOffsetAngle(
    reportId: string,
    pImageId: string,
    bim_offset: number,
    is_default: boolean,
  ) {
    //normalize the
    let normalizedAngle = bim_offset % 360;
    if (normalizedAngle < 0) {
      normalizedAngle += 360;
    }
    let body = {
      report_id: reportId,
      point_image_id: pImageId,
      bim_offset: normalizedAngle,
      is_default: is_default,
    };

    this.endPoint.post('set-point-bim-offset', body, null, 'floors').subscribe(
      async (response) => {
        await this.getPointImagesByFloor(reportId, this.currentPImg.floor_id, false, true);
        if (!is_default) {
          this.currentPImg.bim_offset = bim_offset;
        } else {
          if (this.currentPImg.bim_offset) {
            this.currentPImg.bim_offset = bim_offset;
            this.currentPImg.default_bim_offset = bim_offset;
          } else {
            this.currentPImg.default_bim_offset = bim_offset;
          }
        }

        this._toaster.success(
          this._translocoService.translate('The direction has been adjusted successfully'),
        );
      },
      (error) => {
        console.error('An error occurred:', error);
        this._toaster.error(error.message);
      },
    );
  }

  isOperationEngineer() {
    const storedUserData = localStorage.getItem('user-data');
    return storedUserData
      ? JSON.parse(storedUserData).role_name === 'ORG_OPERATION_ENGINEER'
      : false;
  }

  createBuilding(buildingBody: FormData) {
    return this._projectsApi.createNewProject(buildingBody);
  }

  isArrayOrString(value: string): any {
    try {
      return JSON.parse(value);
    } catch (error) {
      return value;
    }
  }

  get orientationTourSeen(): string {
    return localStorage.getItem('isOrientationTourSeen');
  }

  get bimCompareTourSeen(): string {
    return localStorage.getItem('bimCompareTourSeen');
  }

  setOrientationTourSeen(value: string) {
    let list = [];
    if (this.orientationTourSeen && Array.isArray(this.isArrayOrString(this.orientationTourSeen))) {
      list = JSON.parse(this.orientationTourSeen);
      !this.orientationTourSeen.includes(value) ? list.push(value) : null;
    } else {
      list.push(value);
    }

    localStorage.setItem('isOrientationTourSeen', JSON.stringify(list));
  }

  setBimCompareTourSeen(value: string) {
    let list = [];
    if (this.bimCompareTourSeen && Array.isArray(this.isArrayOrString(this.bimCompareTourSeen))) {
      list = JSON.parse(this.bimCompareTourSeen);
      !this.bimCompareTourSeen.includes(value) ? list.push(value) : null;
    } else {
      list.push(value);
    }

    localStorage.setItem('bimCompareTourSeen', JSON.stringify(list));
  }

  /**
   * Fetches reports that have images for a specific point
   * @param pointId - ID of the point to get reports for
   * @returns Observable with the list of reports that have images for this point
   */
  getReportsWithImagesForPoint(pointId: string): Observable<{
    data: Array<{
      report_id: string;
      report_name: string;
      report_published_at: string;
      report_type?: string;
      has_image?: boolean;
      hasImage?: boolean;
    }>;
  }> {
    return this._projectsApi.getReportsWithImages(pointId);
  }

  /**
   * Video reports: matching split-screen point availability per report.
   */
  getReportsWithVideosForPoint(pointId: string): Observable<{
    data: Array<{
      report_id: string;
      report_name: string;
      report_published_at: string;
      report_type?: string;
      /** When false/0, no matching video point for split; when omitted, treated like image rows (listed ⇒ match). */
      has_matching_point?: boolean | number;
      hasMatchingPoint?: boolean | number;
    }>;
  }> {
    return this._projectsApi.getReportsWithPointVideos(pointId);
  }

  toggleCapturePermission(userId: string, trueOrFalse: boolean): Observable<any> {
    if (trueOrFalse === true) {
      return this.endPoint.post(`v1/authorization/projects/${this.id}/permissions/CAPTURE_REPORT`, {
        user_id: userId,
      });
    } else {
      return this.endPoint.delete(
        `v1/authorization/projects/${this.id}/permissions/CAPTURE_REPORT?user_id=${userId}`,
      );
    }
  }

  /**
   * Check if the current context is NWC client
   * Checks both user's unifier_project_adapter and project's shared_by
   * @returns Promise<boolean> true if NWC client
   */
  async isNwcClient(): Promise<boolean> {
    return this.userService.isNwcClient(this.projectDetails?.shared_by);
  }

  /**
   * Synchronous version - uses cached user data
   * @returns boolean true if NWC client
   */
  isNwcClientSync(): boolean {
    return this.userService.isNwcClientSync(this.projectDetails?.shared_by);
  }
}
